import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconTrash = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_1513_3425)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M6.76562 2.75195C6.89258 2.42188 7.19727 2.21875 7.52734 2.21875H10.4727C10.8027 2.21875 11.1074 2.42188 11.2344 2.75195L11.6406 3.84375H14.0781C14.4082 3.84375 14.6875 4.12305 14.6875 4.45312C14.6875 4.7832 14.4082 5.0625 14.0781 5.0625H3.92188C3.5918 5.0625 3.3125 4.7832 3.3125 4.45312C3.3125 4.12305 3.5918 3.84375 3.92188 3.84375H6.35938L6.76562 2.75195ZM4.63281 14.127L4.04883 6.28125H5.26758L5.85156 14.0254C5.85156 14.2539 6.0293 14.4062 6.25781 14.4062H11.7676C11.9707 14.4062 12.1484 14.2539 12.1738 14.0254L12.7324 6.28125H13.9512L13.3672 14.127C13.3164 14.9648 12.6055 15.625 11.7676 15.625H6.25781C5.39453 15.625 4.68359 14.9648 4.63281 14.127Z",
			fill: "currentColor"
		})
	})
});
export default SvgIconTrash;
